import { combineReducers } from 'redux';
import bookingReducers from 'stores/reducers/booking';
import engravingReducers from 'stores/reducers/engraving';

const rootReducer = combineReducers({
    booking: bookingReducers,
    engraving: engravingReducers
});

export default rootReducer;
